import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useQueryClient } from '@tanstack/react-query';
import { documentWorkSpaceTypeSelector } from 'domain/companies';
import { currentCompanyIdSelector, gridHasNewDocumentsSelector } from 'domain/documents';
import { documentsKeys } from 'domain/documents/queries/keys';
import { agGridRefreshServerSideAction } from 'domain/agGrid';
import { updateWorkSpaceAction } from 'domain/env';

import {
  WorkspaceViewToggleGroup,
  WorkspaceViewToggleButton,
} from 'pages/company/WorkspaceRoute/components/CompanyBarPanel/components/WorkspaceViewToggle/StyledComponents';
import Badge from '@mui/material/Badge';
import Tooltip from 'components/mui/Tooltip';

import TableChartIcon from '@mui/icons-material/TableChart';
import ViewModuleIcon from '@mui/icons-material/ViewModule';

const mapStateToProps = (state) => ({
  viewType: documentWorkSpaceTypeSelector(state),
  companyId: currentCompanyIdSelector(state),
  gridHasChanges: gridHasNewDocumentsSelector(state),
});

const WorkspaceViewToggle = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const { viewType, companyId, gridHasChanges } = useSelector(mapStateToProps);

  const isVisibleGridBadge = viewType === 'grid' && gridHasChanges;

  const onChange = (event, type) => {
    // value === null - when we click on already selected button
    if (type !== null) {
      dispatch(updateWorkSpaceAction({ companyId, type }));
    } else if (viewType === 'grid' && gridHasChanges) {
      // Red-dot refresh (user-initiated): refresh grid rows AND invalidate documents/aggregations
      // so doctype tabs / sub-type chips refetch in lockstep — they describe the same docs.
      dispatch(agGridRefreshServerSideAction(false));
      queryClient.invalidateQueries({ queryKey: documentsKeys.aggregations() });
    }
  };

  return (
    <WorkspaceViewToggleGroup exclusive size="small" onChange={onChange} value={viewType}>
      <WorkspaceViewToggleButton value="grid">
        <Tooltip
          t={{ id: 'company.workspace.barSwitcher.grid.updateTooltip', defaultMessage: 'Refresh the grid' }}
          disabled={!isVisibleGridBadge}
        >
          <Badge
            // component={DocumentsViewToggleButton} // push badge to wrapper
            invisible={!isVisibleGridBadge}
            variant="dot"
            color="error"
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            <TableChartIcon />
          </Badge>
        </Tooltip>
      </WorkspaceViewToggleButton>
      <WorkspaceViewToggleButton value="tile">
        <ViewModuleIcon />
      </WorkspaceViewToggleButton>
    </WorkspaceViewToggleGroup>
  );
};

export default WorkspaceViewToggle;
